import React from 'react';
import { Link } from 'react-router-dom';
import { BrandId, getBrandIdFromHostname } from '@delta-defense/delta-utils';

//custom
import AuthButton from '../AuthButton/AuthButton';
import Title from '../Title/Title';
import { getStylesByBrand } from '../../utilities/getStylesByBrand';

const FourOFour = () => {
  const brandId = getBrandIdFromHostname();
  const brandStyles = getStylesByBrand(brandId as BrandId);

  return (
    <div className="mt-5 text-center">
      <Title textPosition="auth-title--center" name="404" />
      <p style={{ textAlign: 'center', fontSize: '1.5rem', color: brandStyles?.textColor }}>Sorry, page not found.</p>
      <Link to={`/${window.location.search}`} replace>
        <AuthButton style={{ marginTop: '0' }} color={brandStyles?.button} text="Go Back" />
      </Link>
    </div>
  );
};

export default FourOFour;
